import { createSelector } from '@ngrx/store';

import { getNotificationsSelector } from '..';
import { NotificationsState } from './notifications.reducer';

export const selectNotificationOpened = createSelector(
  getNotificationsSelector,
  (state: NotificationsState): boolean => state.opened
);
